import React from 'react';
import Button from '@/components/common/Button/Button';
import styles from './GiftBanner.module.css';

/**
 * GiftBanner Component
 * Promotional banner for gift cards page
 */
const GiftBanner = ({ onActivateClick }) => {

  return (
    <>
      <header className={styles.welcomeBanner}>
        {/* Purple Blur Background */}
        <div className={styles.purpleBlur}></div>
        
        {/* Gift Box Image */}
        <img 
          className={styles.bannerImage}
          src="/assets/images/bonus-welcome-banner.webp"
          alt="Gift Box"
          loading="lazy"
        />
        
        {/* Content Section */}
        <div className={styles.bannerContent}>
          <h1 className={styles.bannerTitle}>
            Gift Card <span className={styles.bannerTitleHighlight}>Vouchers</span>
          </h1>
          <p className={styles.bannerDescription}>
            Activate your gift card vouchers with unique codes. Complete wager requirements and claim your rewards to boost your wallet balance.
          </p>

          <div className={styles.bannerButtonContainer}>
            <Button
              variant="primary"
              size="lg"
              onClick={onActivateClick}
              className={styles.activateButton}
            >
              Activate by code
            </Button>
          </div>
        </div>
      </header>
    </>
  );
};

export default GiftBanner;
